export const columns = [
  {
    key: 'id',
    label: 'ID',
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'patient_name',
    label: 'Nama Pasien',
    align: 'text-left',
    classHead: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'patient_birth_date',
    label: 'Tanggal Lahir',
    align: 'text-left',
    classHead: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'patient_nik',
    label: 'No. KTP',
    align: 'text-left',
    classHead: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'patient_policy_number',
    label: 'No. Polis',
    align: 'text-left',
    classCell: 'text-nowrap',
    classHead: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'insurance_name',
    label: 'Asuransi',
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    align: 'text-left',
    classCell: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'total_claim',
    label: 'Total Klaim',
    align: 'text-center',
    classCell: 'text-nowrap',
    classHead: 'text-nowrap',
    isSortable: true,
  },
  {
    key: 'actions',
    label: '',
    align: 'text-right',
    classCell: 'sticky-cell',
    classHead: 'sticky-cell-head',
  },
];
